import React from 'react'
import EmailEditor from 'components/App/DesktopView/shared/Composer/Email/Editor'

const NewEmailEditor = ({ config, ...rest }) => {
  return <EmailEditor placeholder={'Type your email here...'} {...rest} />
}

export default NewEmailEditor
